<template>
  <div class="boothImg">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>参展</BreadcrumbItem>
          <BreadcrumbItem>我的展会图</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
    </div>

    <div class="boothImg-content">
      <img v-if="imgUrl" :src="imgUrl">
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from '@assets/config.json';

export default {
  name: "exhibition-info-boothImg",
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      joinInfo: "loginModule/getJoinInfo",
      exhibition: "loginModule/getExhibition"
    }),
    imgUrl() {
      return this.joinInfo.myBooth;
    }
  },
  created() {
  }
};
</script>

<style scoped lang="scss">
.boothImg {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 30px;
    padding: 0 40px;
    min-height: 500px;
    background: #fff;
    display: flex;
    align-items: center;
    img {
      width: 100%;
      height: auto;
    }
    p {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
